import { EventBus } from '../../infrastructure/commons/eventBus/eventBus';
/**
 * RegisterEventServiceBus - Event bus controller
 */
export default class RegisterEventServiceBus {
    /**
     * Constructor
     */
    constructor() {
        /**
          * Register method to called for the event
          * @param eventType Event to lister
          * @param callback Method to called
          * @returns
          */
        this.handle = async (eventType, callback) => {
            return this._eventBus.subscribe(eventType, callback);
        };
        this.dispatch = async (eventType, payload) => {
            return this._eventBus.dispatch(eventType, payload);
        };
        this._eventBus = EventBus.getInstance();
    }
}
